"use client";

import ClearIcon from '@mui/icons-material/Clear';
import { useProductCompare } from "@/lib/providers/product-compare-provider";
import { cn } from "@/lib/utils";

interface ClearButtonProps {
    itemId: string;
    className?: string;
}

const ClearProductCompareButton = ({ itemId, className }: ClearButtonProps) => {
    const { removeItemFromCompare } = useProductCompare();
    const handleClearItem = async (itemId: string, e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        await removeItemFromCompare({
            msProductId: itemId
        });
    };
    const classNameText = className ? className : 'absolute -top-1.5 -right-1';

    return (
        <div 
            className={cn("p-2 bg-c2 rounded-full w-[20px] h-[20px] flex justify-center items-center hover:bg-price", classNameText)}
            onClick={(e) => handleClearItem(itemId, e)}
        >
            <ClearIcon
                className="cursor-pointer text-sm text-white"
            />
        </div>
    );
}

export default ClearProductCompareButton;